(function($) {
	/*
	$.fn.loadFormDates = function(chart, urlappend, callback) {
		var chart_parts = chart.split("."); // Needs controller/model specified.
		var url = "/"+chart_parts[0]+"/chart_dates/"+chart_parts[1]+"/"+urlappend;

		$.post(url, null, function(whenlist) {

			for(var whentarget in whenlist)
			{
				var options = whenlist[whentarget];
				var now = calculateNow(whentarget);
				// how can we honor the
				$('#'+whentarget).setoptions(options,null,now); // Assumes #week, #quarter, etc...
			}

			if(typeof callback == 'function')
			{
				callback();
			}


			// Visibility is handled by the page code.
		});

	};
	*/

	// Vanida: added orderOverride inorder to look for a "order" property.
	var default_opts = {
		orderOverride: false,
		smooth: false,
		// not implemented yet... verticalGrid: true,
		xdateformat: "m/d/Y",
		pointdateformat: "M d Y",
		xLabelAngle: 45,
		parseTime: false,
		click: function(i, row) {
			// default is drilldown. May go to separate page, or may disable.
			console.log(row);
			// should be able to click on a group of months and go to that quarter,
			// or quarter's week and go to month
			// IE need raw parseable dates, 2014-11-23, 2014 Q3, 2014 W14, 2011-10
			// leave it up to JS to parse dates
			//
			// XXX "week" dropdown broken/missing...
		}
	};

	/*
	$.fn.lineGraph = function(url)
	{
		var target = this;
		$(target).html(''); //clear
		$(target).unbind('click');

		$.post(url, params, function(response) {

			var settings = response.settings;
			var formattedData = formatData(response.data, settings);

			$(target).graph_line(formattedData, settings);

		}, 'json');
	};
	*/

	$.fn.graphOld = function(chart, custom_opts, data_params) {
		// keep first/second params null to just refresh chart with new form data
		var target = this;

		$(target).html(""); // Clear...
		$(target).unbind("click"); // clear click handlers

		// Load existing data (with new form params) if not provided.
		if (chart) {
			$(target).data("chart", chart); // save
		} else {
			chart = $(target).data("chart"); // load
		}
		if (custom_opts) {
			$(target).data("opts", custom_opts); // save
		} else {
			custom_opts = $(target).data("opts"); // load
		}

		var chart_parts = chart.split("."); // Needs controller/model specified.

		var opts = camelKeys($.extend(true, {}, default_opts, custom_opts));

		var url = "/" + chart_parts[0] + "/chart/" + chart_parts[1]; // XXX TODO pass other params (date range, year subsets, etc) here
		if (opts.urlappend) {
			if (opts.urlappend[0] != "/") {
				opts.urlappend = "/" + opts.urlappend;
			}
			url += opts.urlappend;
		}

		$(target).loading();

		$.post(
			url,
			data_params,
			function(rawdata) {
				$(target).loading(false);
				var data = null;
				var returned_opts = {};
				if (rawdata instanceof Object && rawdata.data) {
					// More complex data structure with parameter specifiers returned....
					data = formatData(rawdata.data, opts);
					if (rawdata.opts) {
						returned_opts = rawdata.opts;

						opts = camelKeys($.extend(opts, returned_opts)); // extend
					}
				} else {
					data = formatData(rawdata, opts);
				}

				/*
			console.log("DATA=");
			console.log(data);
			*/

				if (!data.data.length) {
					$(target).html(
						"<div class='italic center_text' style='margin-top: 3em;'>No data is available for these dates</div>"
					);
				} else {
					if (opts.type == "line" || !opts.type) {
						//DEFAULT
						$(target).graph_line(data, opts);
					} else if (opts.type == "bar") {
						$(target).graph_bar(data, opts);
					}
				}
			},
			"json"
		);
	};

	calculateNow = function(
		span // year, quarter, month, week, day; get now so dropdowns are sensible on load.
	) {
		d = new Date();

		if (span == "year") {
			return d.format("Y");
		} else if (span == "quarter") {
			var month = d.getMonth() + 1; // starts with 0
			var quarter = Math.ceil(month / 3);
			return d.format("Y Q") + quarter;
		} else if (span == "month") {
			return d.format("Y-m");
		} else if (span == "week") {
			return d.format("Y \\WW");
		} else {
			return d.format("Y-m-d");
		}
	};

	camelKeys = function(opts) {
		var out = {};
		for (var k in opts) {
			if (k.match(/_/)) {
				// ONLY if needed, ie WILL lower case everything (ie ruin existing camel case)
				ck = k.camelize(true); // start lower
			} else {
				ck = k; // Not needed, or already done.
			}
			out[ck] = opts[k];
		}

		return out;
	};

	// Vanida: adjust it for order overrride where there is a 'value' property.
	formatData = function(rawdata, opts) {
		// Raw data: { "Label 1": [ [x,y], [x,y], [x,y] ], "Label 2": [ [x,y], [x,y], [x,y] ] }
		// OR: [ [x,y], [x,y], [x,y] ]

		// Raw data keys (not i.e. "California Group") needs to take out order
		// number and underscore.
		var temp = {};
		var formatedRawData = {};

		// console.log("RAWDATA=");
		// console.log(rawdata);

		// for(var object in rawdata) {
		// 	var tempData = rawdata[object];
		// 	for(var key in tempData) {
		// 		var strKeyArr = key.split("_");
		// 		var strData = tempData[key];

		// 		// The key was written with a number appended with an underscore
		// 		// inorder to be easily split.
		// 		if(strKeyArr.length > 1){
		// 			temp[strKeyArr[1]] = strData;
		// 		}
		// 	}

		// 	console.log("Peaches=");
		// 	console.log(temp);
		// 	formatedRawData[object] = temp;
		// 	temp = {};
		// }

		if (!opts) {
			opts = {};
		}

		var pretty = {
			colors: [],
			labels: [],
			data: [],
			ykeys: [] // keys for graph
		};
		var coords = {};

		var ykeys = {
			y1: true
		};

		var n = 0;
		for (var i in rawdata) {
			var j = rawdata[i];
			if (j instanceof Object) {
				// coord set (multiple series)
				//console.log("MULT SERIES");
				/* Needs to look like:
				 	[x: January, y1: set1, y2: set2]

					thus we need to assign FIRST to the KEY (January), THEN, transfer to an array list.
				 */
				var sery = i;
				pretty.labels.push(sery + " " + (opts.xlabel ? opts.xlabel : ""));
				//console.log("jarray=");
				//console.log(j);
				// Intermediate data needs to be: { January: [y1: n, y2: m] }
				for (var x in j) {
					//Vanida need to adust for orderOverride which will have a 'value' property
					//in addition to an 'order' property. Though there is no need to use
					//the order property to order anything as the current need is to order
					//by date if a full date was used for the x-axis, and - if there isn't a full date -
					//order as when the data was computed from server.
					var y = null;
					var objectY = null;
					if (opts.orderOverride) {
						y = j[x].value;
					} else {
						y = j[x];
					}

					var ykey = "y" + (parseInt(n) + 1);
					ykeys[ykey] = true;
					if (!coords[x]) {
						coords[x] = {};
					}

					coords[x][ykey] = y;
					//console.log("SETTING "+x+", "+ykey+"="+y);
				}
			} else {
				// Simple data pairs (one series)
				//console.log("ONE SERIES");
				if (!opts.xlabel) {
					opts.xlabel = "Value";
				}
				pretty.labels.push(opts.xlabel);

				var x = i;
				var y = j;
				var ykey = "y1";

				//console.log("X="+x+",Y="+y);
				if (!coords[x]) {
					coords[x] = {};
				}
				coords[x][ykey] = y;
			}
			n++;
			pretty.colors.push(generateColor(n));
		}

		// console.log("COORDS=");
		// console.log(coords);

		// Now translate coords into right data structure.
		// FROM (grouped y's based on same x coord: { x1: {y1:1,y2:2}, x2: {y1:1,y2:2} }
		// TO: [ {x: 1, y1: 1}, {x: 2, y1: 2}, {x: 3, y1: 3} ]

		for (var x in coords) {
			var ys = coords[x];

			var coord = {
				x: x
			};
			for (var ykey in ys) {
				coord[ykey] = ys[ykey];
				ykeys[ykey] = true;
			}

			pretty.data.push(coord);
		}

		var ykeylist = [];
		for (var ykey in ykeys) {
			ykeylist.push(ykey);
		}
		pretty.ykeys = ykeylist;

		// console.log("STRUCT=");
		// console.log(pretty);

		return pretty;
	};

	generateColor = function(i) {
		var base = [
			"#00CC00",
			"#0000CC",
			"#CC0000",
			"#01CCCE",
			"#CCA6CB",
			"#CCAA66",
			"#006401",
			"#010067",
			"#95003A",
			"#007DB5",
			"#CC00C6",
			"#774D00",
			"#00AE7E"
		];
		return base[i % base.length];
	};

	dateFormat = function(
		d,
		params // Hover boxes, more detailed
	) {
		var ymd = new Date(d).format("Y-m-d").toString();

		/*
		console.log("D="+d);
		console.log("YMD="+ymd);
		*/

		var unit = $(params.spantarget).val();

		if (unit == "year") {
			// show month
			return new Date(d).format("F Y").toString();
		} else if (unit == "quarter") {
			// show week
			var startweek = new Date(moment(ymd, "YYYY-MM-DD").days(0))
				.format("M j")
				.toString();
			var endweek = new Date(moment(ymd, "YYYY-MM-DD").days(6))
				.format("M j")
				.toString();
			return startweek + " - " + endweek;
		} else if (unit == "month") {
			// show day
			return new Date(d).format("D M j").toString();
		} else if (unit == "week") {
			// show day
			return new Date(d).format("D M j").toString();
		}
		return new Date(d).format("m/d/Y").toString();
	};

	$.fn.graph = function(opts) {
		var target = this;
		$(target).html(
			"<div class='jumbotron alert alert-info center_align'><h1>Loading...</h1><div class='progress'><div class='progress-bar progress-bar-striped active' style='width: 100%'></div></div></div>"
		);

		$.post(opts.url, function(results) {
			$(target).html(""); // DONE

			//console.log(data);
			//console.log(results.data instanceof Object && $.isEmptyObject(results.data));
			//console.log(results.data instanceof Array && !results.data.length);

			// array not empty AND hash not empty
			if (
				(results.data instanceof Object && $.isEmptyObject(results.data)) ||
				(results.data instanceof Array && !results.data.length)
			) {
				if (opts.title_id) {
					$("#" + opts.title_id).html("");
				}
				$(target).html(""); //<div class='alert alert-info center_align clip'><h3>NO DATA</h3></div>");
				return;
			}

			// console.log('PRE_RAWDATA=');
			// console.log(results.data);

			$(target).graph_data(results.data, opts);
		});
	};

	$.fn.graph_data = function(results, opts) {
		var target = this;

		// Vanida: Got to add the opts now that we are dealing with
		// making our own ordering structure.
		data = formatData(results, opts);

		// Vanida: If there is no orderOverride, carryon as ususal with the ordering.
		// This stops the sorting base on date for items that cannot be ordered by date.
		if (!opts.orderOverride) {
			// Sort the data.data (it is an array of objects) by x.
			// x is a date in string form so convert to date object to
			// properly sort.
			// Sorting is Ascending.
			data.data.sort(function(a, b) {
				a = new Date(a.x);
				b = new Date(b.x);

				return a < b ? -1 : a > b ? 1 : 0;
			});
		}

		var params = $.extend(
			{
				type: "line", // we have to switch to different functions based on this
				element: target,
				data: data.data,
				xkey: "x",
				parseTime: false,
				lineColors: data.colors,
				trendLineColors: data.colors,
				ykeys: data.ykeys ? data.ykeys : ["y"],
				labels: data.labels ? data.labels : []
			},
			opts
		);

		if (params.parseTime) {
			// standardized axis/label format
			params.xLabelFormat = function(d) {
				return dateFormat(d, params);
			};
			params.dateFormat = function(d) {
				return dateFormat(d, params);
			};
		}

		graphObject = null;
		if (params.type == "bar") {
			graphObject = Morris.Bar(params);
		} else if (params.type == "line") {
			graphObject = Morris.Line(params);
		} else {
			alert("Cannot load graph, style not valid/specified");
		}

		$(target).data("graphObject", graphObject);
		if (opts.click) {
			graphObject.on("click", opts.click);
		}
	};

	$.fn.graph_bar = function(data, opts) {
		var target = this;
		var params = $.extend(
			{
				responsive: true,
				element: target,
				data: data.data,
				xkey: "x",
				ykeys: data.ykeys,
				labels: data.labels
			},
			opts
		);

		if (params.parseTime) {
			// standardized axis/label format
			params.xLabelFormat = function(d) {
				return dateFormat(d, params);
			};
			params.dateFormat = function(d) {
				return dateFormat(d, params);
			};
		}

		$(target).data("graphObject", (graphObject = Morris.Bar(params)));
		graphObject.on("click", opts.click);
	};

	var default_load_params = {
		form: "#chartForm",
		spantarget: "#datespan",
		unitstarget: "#units",
		whentarget: {
			year: "#year",
			quarter: "#quarter",
			month: "#month",
			week: "#week"
		}
	};

	// we should call THIS to reload, so title can be changed as well.
	$.fn.loadGraph = function(
		custom_params // load graph based on link data, etc.
	) {
		var container = this;
		if (custom_params === null) {
			// load
			custom_params = $(container).data("custom_params");
		} else {
			// save
			$(container).data("custom_params", custom_params);
		}

		var params = $.extend(true, {}, default_load_params, custom_params);

		// Load units from link
		$(params.unitstarget)
			.parent()
			.hide();

		var units = params.units;

		if (units) {
			$(params.unitstarget)
				.setoptions(units)
				.parent()
				.show();
		}

		var unit = $(params.unitstarget).val();

		// Now set click handler (depends on datespan)
		// allow for 'click' to be a url (get translated here-ish)
		if (custom_params.click) {
			if (typeof custom_params.click == "string") {
				// url
				var url = custom_params.click;
				params.click = function(i, row) {
					$(container).loading(true);
					var append = row.x;
					if (params.spantarget && params.whentarget) {
						var span = $(params.spantarget).val();
						if (span) {
							var when = $(params.whentarget[span]).val();
							append += "/" + span + ":" + when;
						}
						// ALSO include current date span
					}
					window.location = url + append; // if function param, url should end in /, otherwise, /paramName:
				};
			} // else function, can deal with stuff itself.
		} else {
			params.click = function(i, row) {
				var ymd = row.x;
				var d = new Date(ymd);
				var month = d.getMonth() + 1; // Starts with 0
				var quarter = Math.ceil(month / 3);
				//console.log(row.x+",M="+month+",Q="+quarter);

				var span = $(params.spantarget).val();

				//console.log("SPAN="+span);

				if (span == "year") {
					// drill down to quarter
					var newdate = d.format("Y Q") + quarter;
					//console.log("NEW="+newdate);

					$(params.spantarget).val("quarter");
					$(params.form)
						.find(".spantype")
						.hide();
					$(params.whentarget.quarter)
						.val(newdate)
						.show();
					$(params.form).submit();
				} else if (span == "quarter") {
					// drill down to month
					var newdate = d.format("Y-m").toString();
					//console.log("NEW="+newdate);

					$(params.spantarget).val("month");
					$(params.form)
						.find(".spantype")
						.hide();
					$(params.whentarget.month)
						.val(newdate)
						.show();
					$(params.form).submit();
				} else if (span == "month") {
					// drill down to week
					var newdate = d.format("Y \\WW").toString();
					//console.log("NEW="+newdate);

					$(params.spantarget).val("week");
					$(params.form)
						.find(".spantype")
						.hide();
					$(params.whentarget.week)
						.val(newdate)
						.show();
					$(params.form).submit();
				} // else, already down as far as can go
			};
		}

		//params.parse_time = false;

		// Fix post_units and hover/xlabel and title based on units selected.
		var postUnits = params.post_units;
		var titles = params.title;
		var xlabels = params.xlabel;

		if (typeof postUnits == "object") {
			params.post_units = postUnits[unit] ? postUnits[unit] : "";
		}
		if (typeof titles == "object") {
			params.title = titles[unit] ? titles[unit] : "";
		}
		if (typeof xlabels == "object") {
			params.xlabel = xlabels[unit] ? xlabels[unit] : "";
		}

		// subtitle
		var spanunit = $(params.spantarget).val();
		var spanname = $(params.whentarget[spanunit])
			.find("option:selected")
			.text();
		$(container)
			.find(".subtitle")
			.html(spanname ? " &mdash; " + spanname : "");

		// Now update graph..
		$(container)
			.find(".title")
			.html(params.title);

		var form = $.extend({}, params.params, $(params.form).serializeObject());

		$(container)
			.find(".graph")
			.graph(params.chart, params, form);
	};

	$.fn.pie_graph = function(opts) {
		var target = this;
		$(target).html(
			"<div class='alert alert-info center_align clip'><h3>Loading...</h3><div class='progress'><div class='progress-bar progress-bar-striped active' style='width: 100%'></div></div></div>"
		);

		//google.setOnLoadCallback(function() {
		console.log(opts.url);
		$.get(opts.url, function(response) {
			if (!response || !response.data || !response.data.length) {
				$(target).html(""); //<div class='alert alert-info center_align clip'><h3>NO DATA</h3></div>");
				return;
			}
			// convert data points to floats.
			var data = [];
			if (!opts.columns) {
				opts.columns = ["Key", "Value"];
			}
			data[0] = opts.columns;
			for (var i = 0; i < response.data.length; i++) {
				data[i + 1] = [response.data[i][0], parseFloat(response.data[i][1])];
			}
			//console.log(data);
			//
			var table = new google.visualization.arrayToDataTable(data);

			var formatter = new google.visualization.NumberFormat({
				fractionDigits: 0
			});
			formatter.format(table, 1);

			var defaults = {
				//title: "Pounds Delivered by Variety (YTD)",
				responsive: true,
				//OLD SETTING -> width: $(target).width()*1.25
				width: $(target).width(),
				height: $(target).width(), // square-ish.
				legend: {
					position: "none"
				},
				is3D: false,
				sliceVisibilityThreshold: 0
			};
			var settings = $.extend({}, defaults, opts);
			//console.log(settings);

			var chart = new google.visualization.PieChart($(target).get(0));
			chart.draw(table, settings);
		});
		//});
	};

	$.fn.bar_graph = function(opts) {
		/* json response expects  { data: [ [x1,y1], [x2,y2] ... ] } */
		var target = this;
		$(target).html(
			"<div class='alert alert-info center_align clip'><h3>Loading...</h3><div class='progress'><div class='progress-bar progress-bar-striped active' style='width: 100%'></div></div></div>"
		);

		//console.log("BAR");
		//console.log(google);

		//google.setOnLoadCallback(function() {
		//console.log("GOOGLE LOAD BAR");
		console.log(opts.url);
		$.get(opts.url, function(response) {
			if (!response || !response.data || !response.data.length) {
				console.log("NO DATA FOR GOOGLE");
				$(target).html(""); //<div class='alert alert-info center_align clip'><h3>NO DATA</h3></div>");
				return;
			}
			//console.log("GOOGLE DATA=");
			//console.log(response.data);

			// convert data points to floats.
			var data = [];
			if (!opts.columns) {
				opts.columns = ["Key", "Value"];
			}
			data[0] = opts.columns;
			for (var i = 0; i < response.data.length; i++) {
				data[i + 1] = [response.data[i][0], parseFloat(response.data[i][1])];
			}
			//console.log("FORMATTED=");
			//console.log(data);
			//
			var table = new google.visualization.arrayToDataTable(data);

			// Trick to get different colors. (FAIL)
			/*
			var table = new google.visualization.DataTable();
			for(var i = 0; i < response.data.length; i++)
			{
				table.addColumn('number', response.data[i][0]);
			}
			table.addRows(2);
			for(var i = 0; i < response.data.length; i++)
			{
				table.setValue(0, i, parseFloat(response.data[i][1]));
			}
			*/

			if (opts.formatter) {
				var formatter = new google.visualization.NumberFormat(opts.formatter);
				formatter.format(table, 1);
			}

			var settings = {
				//title: "Pounds Delivered by Variety (YTD)",
				//OLD SETTING -> width: $(target).width()*1.25,
				width: $(target).width(),
				height: $(target).width(), //square-ish.
				legend: {
					position: "none"
				}
			};

			options = $.extend({}, settings, opts);
			var chart = new google.visualization.BarChart($(target).get(0));
			chart.draw(table, options);
		});
		//});
	};

	$.fn.pie_graphOLD = function(opts) {
		var target = this;
		$(target).html(
			"<div class='jumbotron alert alert-info center_align'><h1>Loading...</h1><div class='progress'><div class='progress-bar progress-bar-striped active' style='width: 100%'></div></div></div>"
		);

		var defaults = {
			animation: false,
			responsive: true,
			segmentShowStroke: false,
			//legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>"
			tooltipTemplate: "<%if (label){%><%=label%><br/>\n<%}%><%= value %>",
			multiTooltipTemplate: "<%= value %> SH<br/>\nIT"
		};

		var options = $.extend({}, defaults, opts);

		$.post(options.url, function(data) {
			// dynamic width/height? ie if screen change/rotate?
			$(target).html("<canvas class='width100p'></canvas>"); // do we need width/height?
			var canvas = $(target)
				.find("canvas")
				.get(0);
			var ctx = canvas.getContext("2d");

			// Make canvas square. explicit height.
			$(canvas).attr("width", $(canvas).width());
			$(canvas).attr("height", $(canvas).width());

			// Convert data properly... from [Foo 1: y1, Foo 2: y2,Foo 3: y3, Foo 4: y4] to {value: y1, label: Foo 1}...
			var struct = [];
			var i = 0;
			for (var k in data.data) {
				struct[i++] = {
					value: data.data[k],
					label: k
				};
			}

			//console.log("DATA=");
			//console.log(struct);

			var pie = new Chart(ctx).Pie(struct, options);
		});
	};
})(jQuery);
